module.exports = __webpack_public_path__ + "img/刘华俊副教授.3f797679.jpg";